<div class="table-filters-wrapper">
    <app-selected-filters 
        [filterTags]="filterTags"
        (updateTags)="updateFilterTags($event)" 
    ></app-selected-filters>
</div>